import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import 'react-phone-input-2/lib/plain.css';
import './phoneNumberInput.css';

const PhoneNumberInput = (props) => {
  const [PhoneInputComponent, setPhoneInputComponent] = useState(null);

  useEffect(() => {
    loadPhoneInputComponent();
  }, []);

  const loadPhoneInputComponent = async () => {
    const component = await import('react-phone-input-2');
    setPhoneInputComponent(() => component.default);
  };

  const country = props.country ? props.country.toLowerCase() : 'us';
  return (
    <div className={`et-phone-number-input-${props.variant}`}>
      {PhoneInputComponent && (
        <PhoneInputComponent
          country={country}
          value={props.value ? (props.value === '000' ? '' : props.value) : ''}
          id={props.id}
          placeholder={props.placeholder}
          onChange={props.onChange}
          countryCodeEditable={true}
          disableDropdown={false}
          disabled={props.disabled}
          onKeyDown={props.onKeyDown}
          // defaultValue={props.defaultValue}
        />
      )}
    </div>
  );
};

PhoneNumberInput.prototype = {
  country: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  variant: PropTypes.oneOf(['outlined', 'plain']),
};

PhoneNumberInput.defaultProps = {
  variant: 'plain',
};

export default PhoneNumberInput;
